import { Row, Col } from 'reactstrap';
import {
  onDelete,
  alphabetMask,
  emailMask,
  mobileMask,
  cpfMask,
} from '../../helpers/masks';

export const Attendee = ({
  index,
  attendee,
  fillAttendee,
  length,
  t,
  htmlId,
}) => {
  const hair_knowledges = t('attendee.fields.hair_knowledge.options', {
    returnObjects: true,
  });
  return (
    <>
      <h3 className='mb-3'>
        Informações do {length === 1 ? '' : `${index + 1}º`} participante
      </h3>
      <Row className='align-items-end'>
        <Col
          md={6}
          className='mb-3'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-cp_code`}
          >
            <i className='bi bi-123 me-2'></i>
            {t('attendee.fields.cp_code')}
          </label>
          <input
            id={`attendee-${index}-name`}
            className='form-control'
            autoComplete='off'
            value={attendee.cp_code}
            disabled={true}
          />
        </Col>
        <Col
          md={6}
          className='mb-3'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-cp_name`}
          >
            <i className='bi bi-building me-2' />
            {t('attendee.fields.cp_name')}
          </label>
          <input
            id={`attendee-${index}-name`}
            className='form-control'
            autoComplete='off'
            value={attendee.cp_name}
            disabled={true}
          />
        </Col>
        {/* <Col
          md={6}
          className='mb-3'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-focal_point`}
          >
            <i className='bi bi-person-bounding-box me-2' />
            {t('attendee.fields.focal_point')}
          </label>
          <input
            id={`attendee-${index}-name`}
            className='form-control'
            autoComplete='off'
            value={attendee.focal_point}
            disabled={true}
          />
        </Col> */}
        <Col
          md={6}
          className='mb-3'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-name`}
          >
            <i className='bi bi-person me-2' />
            {t('attendee.fields.name')}
          </label>
          <input
            id={`attendee-${index}-name`}
            className='form-control'
            autoComplete='off'
            value={attendee.name}
            onChange={(e) => {
              const { value } = e.target;
              const newValue = alphabetMask(value);
              fillAttendee('name', newValue, index);
            }}
          />
        </Col>
        <Col
          md={6}
          className='mb-3'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-role`}
          >
            <i className='bi bi-file-person me-2' />
            {t('attendee.fields.role')}
          </label>
          <input
            id={`attendee-${index}-role`}
            className='form-control'
            autoComplete='off'
            value={attendee.role}
            onChange={(e) => {
              const { value } = e.target;
              const newValue = value;
              fillAttendee('role', newValue, index);
            }}
          />
        </Col>
        <Col
          md={6}
          className='mb-3'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-email`}
          >
            <i className='bi bi-envelope me-2'></i>
            {t('attendee.fields.email')}
          </label>
          <input
            type='email'
            id={`attendee-${index}-email`}
            className='form-control'
            name='email'
            autoComplete='off'
            value={attendee.email}
            onChange={(e) => {
              const { value } = e.target;
              const newValue = emailMask(value);
              fillAttendee('email', newValue, index);
            }}
          />
        </Col>
        <Col
          md={6}
          className='mb-3'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-document`}
          >
            <i className='bi bi-123 me-2'></i>
            {t('attendee.fields.document')}
          </label>
          <input
            type='email'
            id={`attendee-${index}-document`}
            className='form-control'
            name='document'
            autoComplete='off'
            value={attendee.document}
            onChange={(e) => {
              const { value } = e.target;
              const newValue = cpfMask(value);
              fillAttendee('document', newValue, index);
            }}
            onKeyDown={(e) => {
              const newValue = onDelete(e, attendee.document);
              fillAttendee('document', newValue, index);
            }}
          />
        </Col>
        <Col
          md={6}
          className='mb-3'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-mobile`}
          >
            <i className='bi bi-telephone me-2'></i>
            {t('attendee.fields.mobile')}
          </label>
          <input
            id={`attendee-${index}-mobile`}
            className='form-control'
            autoComplete='off'
            value={attendee.mobile}
            maxLength={15}
            onChange={(e) => {
              const { value } = e.target;
              const newValue = mobileMask(value);
              fillAttendee('mobile', newValue, index);
            }}
            onKeyDown={(e) => {
              const newValue = onDelete(e, attendee.mobile);
              fillAttendee('mobile', newValue, index);
            }}
          />
        </Col>

        <Col
          md={6}
          className='mb-3 flex flex-column'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-store_code`}
          >
            <i className='bi bi-shop me-2' />
            {t('attendee.fields.store_code')}
          </label>
          <input
            id={`attendee-${index}-store_code`}
            className='form-control'
            autoComplete='off'
            value={attendee.store_code}
            onChange={(e) => {
              const { value } = e.target;
              const newValue = value;
              fillAttendee('store_code', newValue, index);
            }}
          />
        </Col>
        <Col
          md={6}
          className='mb-3 flex flex-column'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-hair_knowledge`}
          >
            <i className='bi bi-book me-2'></i>
            {t('attendee.fields.hair_knowledge.name')}
          </label>
          <select
            id={`attendee-${index}-hair_knowledge`}
            className='form-control'
            autoComplete='off'
            value={attendee.hair_knowledge}
            onChange={(e) => {
              const { value } = e.target;
              const newValue = value;
              fillAttendee('hair_knowledge', newValue, index);
            }}
          >
            {hair_knowledges.map((item, index) => (
              <option
                key={index}
                value={item.code}
              >
                {item.name}
              </option>
            ))}
          </select>
        </Col>

        <Col
          md={6}
          className='mb-3'
        >
          <div className='form-check'>
            <input
              id={`attendee-${index}-lgpd`}
              className='form-check-input'
              type='checkbox'
              checked={attendee.lgpd}
              onChange={(e) => {
                fillAttendee('lgpd', !attendee.lgpd, index);
              }}
            ></input>
            <label className='form-check-label'>
              <p className='text-justify'>
                {t('attendee.fields.lgpd.start')}{' '}
                <a
                  href={t('attendee.fields.lgpd.link_url')}
                  target={'_blank'}
                  rel='noreferrer'
                >
                  {t('attendee.fields.lgpd.link_text')}
                </a>{' '}
                {t('attendee.fields.lgpd.end')}
              </p>
            </label>
          </div>
        </Col>
      </Row>
    </>
  );
};
